module.exports = __webpack_public_path__ + "img/Logo_ActorsChallenge-21.263ddf5d.svg";